import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { isEmpty } from "lodash";
import SignaturePad from "signature_pad";

@Component({
	selector: "app-cbta-signature-pad",
	templateUrl: "./cbta-signature-pad.component.html",
	styleUrls: ["./cbta-signature-pad.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaSignaturePadComponent implements OnInit {
	@Input() dataUrl?: string;

	@ViewChild("canvas", { static: true }) canvas!: ElementRef;

	sig!: SignaturePad;

	@Output() onSignatureChange = new EventEmitter<{
		file?: File;
		dataUrl?: string;
	}>();

	ngOnInit() {
		this.resizeCanvas();
		this.sig = new SignaturePad(this.canvas.nativeElement);

		// sets default value of signature
		if (!isEmpty(this.dataUrl)) {
			this.setDataUrl(this.dataUrl!);
		}

		// set listener on write signature
		this.sig.addEventListener("endStroke", (_) => {
			this.loadData();
		});
	}

	resizeCanvas() {
		const canvasEl = this.canvas.nativeElement as HTMLCanvasElement;
		const context = canvasEl.getContext("2d");
		const ratio = window.devicePixelRatio || 1;

		const cssWidth = canvasEl.offsetWidth;
		const cssHeight = canvasEl.offsetHeight;

		canvasEl.width = cssWidth * ratio;
		canvasEl.height = cssHeight * ratio;

		canvasEl.style.width = `${cssWidth}px`;
		canvasEl.style.height = `${cssHeight}px`;

		if (context) {
			context.setTransform(1, 0, 0, 1, 0, 0); // Reset any existing transform
			context.scale(ratio, ratio);
		}
	}

	/**
	 * Sets data for the signature pad
	 * @param {string} dataUrl
	 */
	setDataUrl(dataUrl: string) {
		this.resizeCanvas();
		this.sig.fromDataURL(dataUrl).then(() => {
			this.loadData();
		});
	}

	/**
	 * Clears signature data
	 */
	clear() {
		this.sig.clear();
		this.onSignatureChange.emit({});
	}

	/**
	 * Converts base64string into File
	 * (In case the api accepts File as payload)
	 * @param {string} base64String
	 * @returns {File}
	 */
	dataToBlob(base64String: string): File {
		var blobBin = atob(base64String.split(",")[1]);
		var array = [];
		for (var i = 0; i < blobBin.length; i++) {
			array.push(blobBin.charCodeAt(i));
		}

		const blob = new Blob([new Uint8Array(array)], { type: "image/png" });

		const fileName = `siganture-${new Date().getTime()}.png`;

		const file = new File([blob], fileName);

		return file;
	}

	loadData(): void {
		if (this.sig.isEmpty()) {
			this.onSignatureChange.emit({});
			return;
		}

		const dataUrl = this.sig.toDataURL();
		const file = this.dataToBlob(dataUrl);

		this.onSignatureChange.emit({
			file,
			dataUrl,
		});
	}
}
